"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceListRowDTOConverter_1 = require("./PriceListRowDTOConverter");
/**
 * Implementation of {@link PriceListRowDTOConverter}.
 *
 * @author Radek Beran
 */


var PriceListRowDTOConverterImpl =
/*#__PURE__*/
function (_PriceListRowDTOConve) {
  _inherits(PriceListRowDTOConverterImpl, _PriceListRowDTOConve);

  function PriceListRowDTOConverterImpl() {
    _classCallCheck(this, PriceListRowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceListRowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PriceListRowDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      throw new Error("Not implemented (never used)");
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        productId: source.productId,
        groupOfSiteId: source.groupOfSiteId,
        priceCodeId: source.priceCodeId,
        priceCodeTitle: source.priceCodeTitle,
        priceListTypeId: source.priceListTypeId,
        priceListTypeTitle: source.priceListTypeTitle,
        value: conversions.fromBigNumber(source.value)
      });
      return result;
    }
  }]);

  return PriceListRowDTOConverterImpl;
}(PriceListRowDTOConverter_1.PriceListRowDTOConverter);

exports.PriceListRowDTOConverterImpl = PriceListRowDTOConverterImpl;